export type DownloadLatencyOutcome = 'success' | 'failure'

export type DownloadLatencyMode = 'single' | 'bulk'

export const DOWNLOAD_LATENCY_PAGE_ACTION = 'DownloadLatency'
export const LEGACY_DOWNLOAD_LATENCY_PAGE_ACTION = 'LegacyDownloadLatency'

export type DownloadLatencyPageActionName =
	| typeof DOWNLOAD_LATENCY_PAGE_ACTION
	| typeof LEGACY_DOWNLOAD_LATENCY_PAGE_ACTION

export type RecordDownloadLatencyInput = {
	downloadMode: DownloadLatencyMode
	durationMs: number
	fileType: string
	outcome: DownloadLatencyOutcome
	pageActionName: DownloadLatencyPageActionName
	trackCount: number
}

export const recordDownloadLatency = (
	input: RecordDownloadLatencyInput
): void => {
	if (typeof window === 'undefined' || !window.newrelic?.addPageAction) {
		return
	}

	const {
		downloadMode,
		durationMs,
		fileType,
		outcome,
		pageActionName,
		trackCount,
	} = input

	if (trackCount === 0) {
		return
	}

	window.newrelic.addPageAction(pageActionName, {
		downloadMode,
		durationMs,
		fileType,
		latencyPerTrackMs: durationMs / trackCount,
		outcome,
		trackCount,
	})
}
